/**
 * @ngdoc component
 * @name common.component:itxBannerMarketing
 *
 * @param {Function} onCloseBanner Close banner event
 *
 * @description
 * Render the correct marketing banner
 *
 */
 (function () {
    'use strict';

    var itxBannerMarketingCmp = {
        templateUrl: 'banner-marketing.component.html',
        controller: itxBannerMarketingCmpCtrl,
        bindings: {
            onCloseBanner: '&'
        }
    };

    itxBannerMarketingCmpCtrl.$inject = [
        '$q',
        '$scope',
        'itxmSpotUtilsSvc',
        'crmService',
        'NavigationService'
    ];

    function itxBannerMarketingCmpCtrl(
        $q,
        $scope,
        itxmSpotUtilsSvc,
        crmService,
        NavigationService
    ) {
        var _this = this;

        _this.showClose = false;
        _this.banner = 'marketing';
        _this.show = false;

        _this.$onInit = function () {
            _this.isFormNewsletter = false;
            _this.itxPopupLayout = false;
            _this.itxPopupCoverImg = false;
        };

        var componentByStore;
        itxmSpotUtilsSvc.getString('popup_suscripcion_0').then(function (res) {
            var obj = {};
            obj.type = res;
            obj.data = {};
            if (!res || res === null || (res.trim() === '' && iPageAllowed())) {
                return false;
            } else {
                if (res === 'itx-popup-crm') {
                    if (NavigationService.isHomePage() || inditex.iPage == 'ItxCategoryPage') {
                        componentByStore = { type: res };
                        canShowPopupMkt();
                    }
                } else {
                    var promises = _.map(_.range(1, 21), function (i) {
                        return itxmSpotUtilsSvc
                            .getString('popup_suscripcion_' + i)
                            .then(function (res) {
                                obj.data['popup_suscripcion_' + i] = res;
                            });
                    });
                    $q.all(promises).then(function () {
                        componentByStore = obj;
                        canShowPopupMkt();
                    });
                }
            }
        });

        itxmSpotUtilsSvc.getString('popup_suscripcion_1').then(function (res) {
            if (res == 'white') {
                $scope.colorClose = res;
            } else {
                $scope.colorClose = 'black';
            }
        });

        var arrayEvents = [
            'mousemove',
            'mousedown',
            'keypress',
            'DOMMouseScroll',
            'mousewheel',
            'touchmove',
            'MSPointerMove'
        ];
        var allowedPages = [
            'ItxHomePage',
            'ItxHomeMenPage',
            'ItxHomeWomenPage',
            'ItxHomeBgPage',
            'ItxCategoryPage'
        ];
        var timeoutID;
        var waitTime = 180000;
        // ** END **

        /**
         * Al clickar sobre cerrar el banner
         */
        _this.closePopup = function () {
            _this.onCloseBanner({ banner: _this.banner, hideBannerNextTime: true });
        };

        function iPageAllowed() {
            if (inditex.iPage !== 'itxWorldWidePage') {
                return true;
            } else {
                return false;
            }
        }

        function closePopupForever() {
            _this.onCloseBanner({ banner: _this.banner, hideBannerNextTime: true });
        }

        function showPopupMkt() {
            $scope.cmpInject = componentByStore;

            _this.data = $scope.cmpInject.data;

            switch ($scope.cmpInject.type) {
                case 'itx-form-newsletter':
                    _this.isFormNewsletter = true;
                    break;
                case 'itx-popup-layout':
                    _this.itxPopupLayout = true;
                    break;
                case 'itxPopupCoverImg':
                    _this.itxPopupCoverImg = true;
                    break;
            }

            _this.showClose = true;
            _this.show = true;

            $scope.$applyAsync();
        }

        function checkStateAllowed() {
            var res = false;

            if (allowedPages.indexOf(inditex.iPage) >= -1) {
                res = true;
            }

            return res;
        }

        function crmDuplicate() {
            //esta función indica si queremos mostrar el popup del CRM cuando ya somos feel.
            return (
                componentByStore && componentByStore.type == 'itx-popup-crm' && crmService.is360()
            );
        }

        function canShowPopupMkt() {
            var clickClosePopup = inditex.getLocalStorage('clickClosePopup');
            var closePopupGeoblocking = inditex.getLocalStorage('LAST_STORE_GEOBLOCKING');
            var lastStore = inditex.getLocalStorage('LAST_STORE');
            var isHomePage = NavigationService.isHomePage();
            if ((isHomePage && (closePopupGeoblocking || lastStore)) || !isHomePage) {
                if (!clickClosePopup && checkStateAllowed() && !crmDuplicate()) {
                    setup('delay');
                }
            }
        }

        function setup(delay) {
            if (delay == 'delay') {
                setTimeout(function () {
                    showPopupMkt();
                }, 1500);
            } else {
                showPopupMkt();
            }

            timeoutID = window.setTimeout(closePopupForever, waitTime);
            setTimeout(function () {
                if (document.getElementById('itx-popup-mkt-cmp')) {
                    loopEvents('addEventListener', resetTimer);
                }
            }, waitTime / 2);
        }

        function resetTimer() {
            window.clearTimeout(timeoutID);
            timeoutID = window.setTimeout(closePopupForever, waitTime);
        }

        function loopEvents(typeEvent, callback) {
            for (var i = 0; i < arrayEvents.length; i++) {
                document
                    .getElementById('itx-popup-mkt-cmp')
                    [typeEvent](arrayEvents[i], callback, false);
            }
        }
    }

    ItxCompileCmpJsonCmp.$inject = ['$compile'];

    function ItxCompileCmpJsonCmp($compile) {
        return {
            link: function (scope, element) {
                var template = scope.$parent.compileCmpJson;
                var linkFn = $compile(template);
                var content = linkFn(scope);
                element.append(content);
            }
        };
    }

    angular.module('itxApp.common').component('itxBannerMarketing', itxBannerMarketingCmp);
    // .directive('itxCompileCmpJson', ItxCompileCmpJsonCmp);
})();
